import React, {useEffect, useRef, useState} from "react";
import PersonalInformation from "./PersonalInformation/PersonalInformation";
import PersonalInformationRead from "./PersonalInformation/PersonalInformationRead";
import ProfessionalExperiences from "./ProfessionalExperiences/ProfessionalExperiences";
import EducationAndTraining from "./EducationAndTraining/EducationAndTraining";
import EducationAndTrainingRead from "./EducationAndTraining/EducationAndTrainingRead";
import ProfileOverview from "./ProfileOverview/ProfileOverview";
import LinguisticSkills from "./LinguisticSkills/LinguisticSkills";
import TechnicalSkills from "./TechnicalSkills/TechnicalSkills";
import {
    changePermission,
    createNewCV,
    deletePermissionFromFile,
    manageFileChangesPermission,
    renameFileById,
    updateFileContentByFileId,
    updateFileLocation,
    updateFilePermission

} from "../../../graph-services/GraphServices"
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';
import "react-datepicker/dist/react-datepicker.css";
import _, {cloneDeep} from "lodash";
import {ReferenceCPStatus as status} from "../ReferenceCPStatus"
import OpportunitySelect from "./Opportunity/OpportunitySelect";
import OpportunityRead from "./Opportunity/OpportunityRead";
import ButtonsStrip from "../../UI/ButtonsStrip/ButtonsStrip";
import Aux from "../../../hoc/Auxiliary/Auxiliary";
import {translation} from "../../../I18n/i18n"
import LanguageSelect from "./languageSelect";
import classes from "./CvDetails.module.css"
import {generateDocument} from "../../FileGenerator/DocumentFileGenerator";
import NewExperienceEntity from "../../../Entities/NewExperienceEntity";
import {FileExtensionEnum} from "../../../Enumerations/FileExtensionEnum";
import {getElementFromSkills} from "../utils";

const Accordion = (props) => {

    const [cvDetails] = useState(props.contentFile);
    const [fileId] = useState(props.fileId);
    const [fileName] = useState(props.fileName);
    const [token, setToken] = useState(props.token);
    const [emailBeforeChange, setEmailBeforeChange] = useState(cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text);
    const [surNameBeforeChange] = useState(cvDetails.SkillsPassport.LearnerInfo.Identification.PersonName.Surname._text);
    const [firstNameBeforeChange] = useState(cvDetails.SkillsPassport.LearnerInfo.Identification.PersonName.FirstName);
    let p = cvDetails.SkillsPassport.LearnerInfo.Identification.PersonName;

    let [hasUnsavedExpr, setHasUnsavedExpr] = useState(false);
    let [isOnEditingExpr, setIsOnEditingExpr] = useState(false);
    let [editingExperience, setEditingExperience] = useState({index: -1, experience: cloneDeep(NewExperienceEntity)});
    let [isAnyEmptyExprField, setIsAnyEmptyExprField] = useState(new Function());

    let [userId, setUserId] = useState(Object)
    const [activeStep, setActiveStep] = React.useState(0);
    const handleStep = (step) => () => {
        setActiveStep(step);
    };
    const steps = getSteps();
    let initializeSaveBtn = () => {
        let personalInfo = cvDetails.SkillsPassport.LearnerInfo.Identification;
        let firstName = personalInfo.PersonName.FirstName;
        let surname = personalInfo.PersonName.Surname;
        let contact = personalInfo.ContactInfo.Email.Contact;
        return Object.keys(firstName).length === 0 ||
            Object.keys(surname).length === 0 ||
            Object.keys(contact).length === 0 ||
            firstName._text === "" ||
            surname._text === "" ||
            contact._text === "";
    }
    let initializeAddCommercialBtn = () => {
        return initializeSaveBtn() || (props.isToBeCloned && cvDetails.SkillsPassport.LearnerInfo.opportunity.name === "")
    }
    let [disableBtn, setDisableBtn] = useState(initializeSaveBtn());
    let [disableAddCommercialBtn, setDisableAddCommercialBtn] = useState(initializeAddCommercialBtn);

    // guarantees an always up-to-date token value
    useEffect(() => {
        setToken(props.token)
    }, [props.token])

    // true: when it's about user's CP
    let [isUserCP, setIsUserCP] = useState(false);

    useEffect(() => {
        setIsUserCP(_.isEqual(cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text, props.userEmail));
    }, [props.userEmail, cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text])

    let [hasWriteAccess, setHasWriteAccess] = useState(false);

    useEffect(() => {
        let cpStatus = (cvDetails.SkillsPassport.DocumentInfo.status._text) ?
            cvDetails.SkillsPassport.DocumentInfo.status._text : "";

        // is Admin : always Write&Read
        if (props.isAdminMember || (props.isHrMember && props.isSalesMember)) {
            setHasWriteAccess(true)

            // is HR member : Write&Read for all 'reference' CPs
        } else if (props.isHrMember) {
            setHasWriteAccess(!props.isCommercialCP)

            // is Sales member: Write&Read for all 'commercial' CPs and ('to be completed' Or 'invalidated') 'reference' CPs
        } else if (props.isSalesMember) {
            setHasWriteAccess(props.isCommercialCP || (isUserCP && (cpStatus === status.toBeCompleted.code || cpStatus === status.inValidated.code)))

            // is Consultant: Write&Read for 'to be completed' Or 'invalidated' CPs
        } else {
            setHasWriteAccess(cpStatus === status.toBeCompleted.code || cpStatus === status.inValidated.code)
        }
    }, [props.isAdminMember, props.isHrMember, props.isSalesMember, cvDetails.SkillsPassport.DocumentInfo.status._text, isUserCP])

    let isNewCP = () => {
        return props.isCommercialCP ? props.isToBeCloned : fileId === "";
    }

    //get CV creation steps
    function getSteps() {
        let steps = ['Personal Information', 'Profile Overview', 'Linguistic Skills', 'Technical Skills', 'Education And Training', 'Professional Experiences'];
        if (props.isCommercialCP) {
            steps.unshift("Opportunity");
        }
        return steps
    }

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    function getPersonalSection() {

        return hasWriteAccess ? <PersonalInformation
            dict={props.dict}
            notify={props.notify}
            addToDictionary={props.addToDictionary}
            mandatoryInformationFilled={(v) => handleChangeMandatoryInformation(v)}
            isNewCV={fileId === ""}
            element={cvDetails.SkillsPassport.LearnerInfo}
            lang={props.lang}
            token={token}
            setUserId={setUserId}
            userId={userId}
            allUsers={props.allUsers}
            isAdminMember={props.isAdminMember}
            isHrMember={props.isHrMember}
        /> : <PersonalInformationRead
            mandatoryInformationFilled={(v) => handleChangeMandatoryInformation(v)}
            element={cvDetails.SkillsPassport.LearnerInfo}
            lang={props.lang}
        />
    }

    function getOpportunitySection() {
        return hasWriteAccess ? <OpportunitySelect
            lang={props.lang}
            mandatoryInformationFilled={() => HandleChangeMandatoryCommercialCVInformation()}
            element={cvDetails.SkillsPassport.LearnerInfo.opportunity}
            opportunities={props.opportunities}
            isToBeCloned={props.isToBeCloned}
        /> : <OpportunityRead
            lang={props.lang}
            element={cvDetails.SkillsPassport.LearnerInfo.opportunity}/>
    }

    function getProfileOverviewSection() {
        return <ProfileOverview
            dict={props.dict}
            notify={props.notify}
            addToDictionary={props.addToDictionary}
            lang={props.lang}
            element={cvDetails.SkillsPassport.LearnerInfo}
            hasWriteAccess={hasWriteAccess}
            isHrMember={props.isHrMember}
            isAdminMember={props.isAdminMember}
            isSalesMember={props.isSalesMember}
        />
    }

    function getTechnicalSkillsSection() {
        return <TechnicalSkills
            lang={props.lang}
            dict={props.dict}
            notify={props.notify}
            addToDictionary={props.addToDictionary}
            element={cvDetails.SkillsPassport.LearnerInfo.Skills.TechnicalSkills}
            hasWriteAccess={hasWriteAccess}
        />
    }

    function getEducationAndTrainingSection() {
        return hasWriteAccess ? <EducationAndTraining
                dict={props.dict}
                notify={props.notify}
                addToDictionary={props.addToDictionary}
                lang={props.lang}
                element={getElementFromSkills(cvDetails.SkillsPassport.LearnerInfo.EducationAndTraining)}
                hasWriteAccess={hasWriteAccess}
            /> :
            <EducationAndTrainingRead
                element={getElementFromSkills(cvDetails.SkillsPassport.LearnerInfo.EducationAndTraining)}
                lang={props.lang}
            />
    }

    function getLanguageSkillsSection() {
        cvDetails.SkillsPassport.LearnerInfo.Skills.Linguistic.LanguageList.Description
            = array(cvDetails.SkillsPassport.LearnerInfo.Skills.Linguistic.LanguageList.Description);

        return <LinguisticSkills
            lang={props.lang}
            hasWriteAccess={hasWriteAccess}
            element={cvDetails.SkillsPassport.LearnerInfo.Skills.Linguistic.LanguageList.Description}/>
    }

    function getWorkExperienceSection() {
        cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience
            = array(cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience);
        sortExperiences();

        return <ProfessionalExperiences
            dict={props.dict}
            notify={props.notify}
            addToDictionary={props.addToDictionary}
            lang={props.lang}
            hasWriteAccess={hasWriteAccess}
            element={cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience}
            setHasChanges={setHasUnsavedExpr}
            hasChanges={hasUnsavedExpr}
            setUpdateExpr={setUpdateExpr}
            editingExperience={editingExperience}
            setEditingExperience={setEditingExperience}
            setIsOnEditingExpr={setIsOnEditingExpr}
            isOnEditingExpr={isOnEditingExpr}
            setIsAnyEmptyExprField={setIsAnyEmptyExprField}
            confirmExpr={confirmUnsavedExpr}
            cancelExpr={cancelUnsavedExpr}
            launchUnsavedExprPopup={launchUnsavedExprPopup}
            sortExperiences={() => sortExperiences()}/>
    }

    useEffect(() => {
        let unsavedVersion = editingExperience.index < 0 ? cloneDeep(NewExperienceEntity)
            : cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience[editingExperience.index];
        let savedVersion = editingExperience.experience;

        setHasUnsavedExpr(isOnEditingExpr &&
            (JSON.stringify(unsavedVersion) !== JSON.stringify(savedVersion)));

    }, [editingExperience]);

    function getDateByPeriod(value, period) {
        let year = value["Period"][period]["_attributes"]["year"];
        let month = value["Period"][period]["_attributes"]["month"].replace(
            "--",
            ""
        );
        return year === "" ? new Date() : new Date(year + "/" + month);
    }

    function sortExperiences() {
        let experiences =
            cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience;
        return experiences.length > 0
            ? experiences.sort((a, b) => {
                if (getDateByPeriod(a, "To") > getDateByPeriod(b, "To")) return -1;
                if (getDateByPeriod(a, "To") < getDateByPeriod(b, "To")) return 1;
                if (getDateByPeriod(a, "From") > getDateByPeriod(b, "From"))
                    return -1;
                if (getDateByPeriod(a, "From") < getDateByPeriod(b, "From")) return 1;
            })
            : experiences;
    }

    function getStepContent(stepIndex) {
        let sections = [
            getPersonalSection(),
            getProfileOverviewSection(),
            getLanguageSkillsSection(),
            getTechnicalSkillsSection(),
            getEducationAndTrainingSection(),
            getWorkExperienceSection(),
        ];
        if (props.isCommercialCP) {
            sections.unshift(getOpportunitySection());
        }
        return sections[stepIndex];
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    //disable or enable save button according to mandatory information are encoded or not
    let handleChangeMandatoryInformation = (isAllInformationFilled) => {
        setDisableBtn(!isAllInformationFilled);
    }
    let HandleChangeMandatoryCommercialCVInformation = () => {
        setDisableAddCommercialBtn(disableBtn || cvDetails.SkillsPassport.LearnerInfo.opportunity.name === "")
    }

    let handleLoading = (v) => {
        props.onLoading(v);
    }

    let generateLocalDocument = async (token, webUrl, siteId, fileName, lang, cvDetails, documentType) => {
        if (hasUnsavedChanges(initialContent.current, props.contentFile, props.isCommercialCP) || (emailBeforeChange !== cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text)) {
            props.onLoading(true);
            if (emailBeforeChange !== cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text) {
                await saveNewEmail('read');
            }
            await manageEditCV(false)
        }
        await generateDocument(token, webUrl, siteId, fileName, lang, cvDetails, props, documentType, null)
        setEmailBeforeChange(cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text)
    }

    let getConsultantName = personName => {
        return `${capitalize(personName.FirstName._text)} ${capitalize(personName.Surname._text)}`
    }

    let drawerTitle = isNewCP() ?
        translation(props.lang, `Create New ${props.isCommercialCP ? "Commercial" : "Reference"} Consultant Profile`).concat(props.isCommercialCP ? ` - ${getConsultantName(p)}` : ``)
        : fileName.replace(".xml", "");

    const [consultantEmail, setConsultantEmail] = useState("");

    useEffect(() => {
        if (cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text) {
            setConsultantEmail(cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text);
        }
    }, [cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text])

    let getStatusLocation = (s) => {
        return `${process.env.REACT_APP_REFERENCE_FOLDER}/${Object.values(status).find(e => e.code === s).location}`;
    }

    let changeCVStatus = async (s) => {
        cvDetails.SkillsPassport.DocumentInfo.status = s;

        let r = await updateFileLocation(token, props.siteId, fileId, getStatusLocation(s))
        if (r.ok) {
            if (s === "toBeValidated") {
                await deletePermissionFromFile(token, props.siteId, fileId, props.siteName + " Members")
            }
            return await updateFileContentByFileId(token, props.siteId, fileId, cvDetails)
        } else return r
    }

    // Handle Save
    let manageCreateNewCv = async () => {
        let p = cvDetails.SkillsPassport.LearnerInfo.Identification.PersonName;
        let fileName = `CP - ${getConsultantName(p)} - ` + props.lang.toUpperCase() + ".xml";

        if (props.checkIfExist(fileName)) {
            props.notify("This Consultant Profile name already exists !", "error");
            handleLoading(false)
        } else {
            createNewCV(token, props.siteId, props.driveId, fileName, cvDetails)
                .then(r => {
                    if (r.id) {
                        let newFileId = r.id;
                        changePermission(token, props.siteId, newFileId, consultantEmail, "read")
                            .then(r => {
                                if (r) {
                                    handleLoading(false)
                                    props.reloadReference()
                                    props.notify("The Consultant Profile has been saved !", "success");
                                    props.closeDrawer();
                                } else {
                                    handleLoading(false)
                                    props.notify("The Consultant Profile can not be created !", "error");
                                }
                            })
                    } else {
                        handleLoading(false)
                        props.notify("The Consultant Profile can not be created !", "error");
                    }
                })
        }
    }

    let manageEditCV = async (isExplicit) => {
        await updateFileContentByFileId(token, props.siteId, fileId, cvDetails)
            .then(r => {
                if (r.ok) {
                    if (isExplicit) {
                        handleLoading(false)
                    }

                    props.isCommercialCP ? props.reloadCommercial() : props.reloadReference()
                    if (isExplicit) {
                        props.notify("The Consultant Profile has been updated !", "success");
                        props.closeDrawer();
                    }
                    initialContent.current = props.contentFile;

                } else {
                    handleLoading(false)
                    props.notify("The Consultant Profile can not be updated !", "error");
                }
            })
    }

    let saveNewEmail = async (permissionCode) => {
        return await manageFileChangesPermission(token, props.siteId, fileId, consultantEmail, emailBeforeChange, permissionCode)
    }

    let saveFileHandler = async () => {
        handleLoading(true)
        if (surNameBeforeChange !== p.Surname._text || firstNameBeforeChange !== p.FirstName._text) {
            let content = {
                name: `CP - ${getConsultantName(p)} - ` + props.lang.toUpperCase() + ".xml"
            }
            await renameFileById(token, props.siteId, fileId, content)
        }
        if (cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience.length === 0) {
            cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience = {}
        }
        if (isNewCP()) {
            await manageCreateNewCv();
        } else if (emailBeforeChange !== cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text) {
            let permissionCode = "read"
            if (props.contentFile.SkillsPassport.DocumentInfo.status._text === 'toBECompleted') {
                permissionCode = "write"
            }

            saveNewEmail(permissionCode)
                .then(r => {
                    if (r) {
                        manageEditCV(true);
                    } else {
                        handleLoading(false)
                        props.notify("The Consultant Profile can not be updated !", "error")
                    }
                })
        } else {
            await manageEditCV(true)
        }
    };

    let [versionedFileName, setVersionedFileName] = useState("")

    let computeVersion = (opportunity, fileName) => {
        let matchArr, versions = []
        let exists = false
        let fileBaseName = fileName.replace(".xml", "")

        var selectedClient=props.commercialData.find(cli => cli.client === opportunity.client.name)
        
        if(selectedClient!==undefined && selectedClient!==null){
            let searchOpportunity=selectedClient.opportunities.find(el => el.name === opportunity.name)
            if(searchOpportunity!==undefined && searchOpportunity!==null){
                searchOpportunity.cvs.forEach(el => {
                    if (el.name.startsWith(fileBaseName)) {
                        // gets all digits in parentheses
                        matchArr = el.name.match(/\(([\d]+)\)/)
                        exists = true
                        Array.isArray(matchArr) && versions.push(matchArr[1])
                    }
                })
            }  
        }
        
        // returns the higher existing version + 1
        return !exists ? 0 : versions.length > 0 ? Math.max(...versions) + 1 : 1
    }

    // Handle Create New Commercial
    let handleCreateNewCommercial = async (e) => {
        let opportunity = cvDetails.SkillsPassport.LearnerInfo.opportunity;
        let fileName = `CP - ${opportunity.name} - ${getConsultantName(p)} - ${props.lang.toUpperCase()}.xml`
        let newVersion = computeVersion(opportunity, fileName)
        handleLoading(true)

        if (newVersion > 0) {
            setVersionedFileName(`CP - ${opportunity.name} - ${getConsultantName(p)} - ${props.lang.toUpperCase()} (${newVersion}).xml`)
            launchPopup(e, buttons.addCommercialCV)
            handleLoading(false)
        } else {
            saveNewCommercial(fileName)
        }
    }

    let saveNewCommercial = (fileName) => {
        let opportunity = cvDetails.SkillsPassport.LearnerInfo.opportunity;

        createNewCV(token, props.siteId, opportunity.id, fileName, cvDetails)
            .then(r => {
                if (r.id) {
                    handleLoading(false)
                    props.reloadCommercial()
                    props.notify("The Consultant Profile has been saved !", 'success')
                    props.closeDrawer();
                } else if (r.error) {
                    handleLoading(false)
                    props.notify(r.error.message,
                        'error')
                } else {
                    handleLoading(false)
                    props.notify(`An error has occurred !`,
                        'error')
                }
            })
    }

    // Handle Close
    const initialContent = useRef(cloneDeep(props.contentFile));

    let discardChanges = () => {
        hidePopup();
        props.closeDrawer();
    }

    let handleCloseDrawer = (e) => {
        hasUnsavedChanges(initialContent.current, props.contentFile, props.isCommercialCP) ?
            launchPopup(e, buttons.close) : discardChanges();
    }

    // Handle Force Validation
    let forceValidationHandler = () => {
        hidePopup();
        handleLoading(true);
        changeCVStatus(status.validated.code)
            .then(async r => {
                if (r.ok) {
                    if (emailBeforeChange !== cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text) {
                        let permissionCode = "read"
                        saveNewEmail(permissionCode)
                            .then(r => {
                                if (r) {
                                    manageConfigurationNotificationAndDrawerAfterForceValidation(true)
                                } else {
                                    manageConfigurationNotificationAndDrawerAfterForceValidation(false)
                                }
                            })
                    } else {
                        let result = await updateFilePermission(token, props.siteId, fileId, consultantEmail, "read")
                        let perm = result.length > 0 && result[0].id;
                        manageConfigurationNotificationAndDrawerAfterForceValidation(perm)
                    }

                } else {
                    handleLoading(false)
                    props.notify("An error has occurred !", "error");
                }
            });
    }

    let manageConfigurationNotificationAndDrawerAfterForceValidation = (perm) => {
        if (perm) {
            handleLoading(false)
            props.reloadReference()
            props.notify("The Consultant Profile has been validated !", "success");
            props.closeDrawer();

        } else {
            handleLoading(false)
            props.notify("An error has occurred !", "error");
        }
    }
    // Handle Popup
    const [popupLauncher, setPopupLauncher] = useState(null);
    const [openPopup, setOpenPopup] = useState(null);

    let launchPopup = (e, v) => {
        setPopupLauncher(e.currentTarget);
        setOpenPopup(v);
    }

    let hidePopup = () => {
        setPopupLauncher(null);
        setOpenPopup(null);
    }

    let buttons = {
        save: "Save",
        addCommercialCV: "Create",
        share: "Share",
        notify: "Notify HR",
        forceValidation: "Force Validation",
        validate: "Validate",
        invalidate: "Invalidate",
        archive: "Archive",
        generate: "Download",
        close: "Close",
    }

    // is visible by the action button name
    let isBtnVisible = (btn) => {
        let s = cvDetails.SkillsPassport.DocumentInfo.status._text;

        switch (btn) {
            case buttons.save:
                return hasWriteAccess && !props.isToBeCloned;

            /* COMMERCIAL CP & SALES MEMBER */
            case buttons.addCommercialCV:
                return props.isToBeCloned && (props.isSalesMember || props.isAdminMember);

            /* CONSULTANT */
            case buttons.notify:
                // ('to be completed' Or 'invalidated') & ( !Admin & !Hr & !Sales Or (Sales & is user's CP))
                return (s === status.toBeCompleted.code || s === status.inValidated.code) &&
                    ((!props.isHrMember && !props.isAdminMember && !props.isSalesMember) || (props.isSalesMember && isUserCP))

            /* REFERENCE CP & HR MEMBER */
            case buttons.share:
                return !props.isCommercialCP && (props.isHrMember || props.isAdminMember)
                    && ((s === status.validated.code) || ((s === status.created.code) && !isNewCP()));

            case buttons.forceValidation:
                // Reference CP & (Admin Or Hr) & ('created' Or 'to be completed' Or 'invalidated')
                return !props.isCommercialCP && (props.isHrMember || props.isAdminMember) &&
                    ((s === status.created.code && !isNewCP()) || s === status.toBeCompleted.code || s === status.inValidated.code)

            case buttons.validate:
                return !props.isCommercialCP && (props.isHrMember || props.isAdminMember)
                    && (s === status.toBeValidated.code);

            case buttons.invalidate:
                return !props.isCommercialCP && (props.isHrMember || props.isAdminMember)
                    && (s === status.toBeValidated.code);

            case buttons.generate:
                return props.isCommercialCP ? (props.isAdminMember || props.isSalesMember) && !props.isToBeCloned :
                    (props.isHrMember || props.isAdminMember) && s === status.validated.code

            default:
                return false;
        }
    }

    let infoTexts = {
        save: isBtnVisible(buttons.notify)
            && translation(props.lang, `Save changes without notifying HR members`),
        notify: translation(props.lang, `Notify HR members that you have completed filling out`),

        share: translation(props.lang, `Share access with the consultant in order to complete the Consultant Profile`),
        forceValidation: translation(props.lang, `Force validation without notifying the consultant`),
        validate: translation(props.lang, `Set as a valid Consultant Profile`),
        invalidate: translation(props.lang, `Invalidate the changes and share the Consultant Profile again to complete it`),
    }

    let confirmUnsavedExpr = () => {
        if (editingExperience.index < 0) {
            cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience.push(editingExperience.experience);
        } else {
            cvDetails.SkillsPassport.LearnerInfo.WorkExperienceList.WorkExperience.splice(editingExperience.index, 1, editingExperience.experience);
        }
        updateExpr();
        hideUnsavedExprPopup();
    }

    let cancelUnsavedExpr = () => {
        updateExpr();
        hideUnsavedExprPopup();
    }

    // Unsaved Experiences Changes.
    let [unsavedExprPopupLauncher, setUnsavedExprPopupLauncher] = useState(null);
    let [unsavedExprOpenPopup, setUnsavedExprOpenPopup] = useState(false);
    let hideUnsavedExprPopup = () => {
        setUnsavedExprPopupLauncher(null);
        setUnsavedExprOpenPopup(false);
    }
    let launchUnsavedExprPopup = (e) => {
        let confirmBtn = document.getElementById('Confirm')
        setUnsavedExprPopupLauncher(confirmBtn ? confirmBtn : e.currentTarget);
        setUnsavedExprOpenPopup(true);
    }

    let [updateExpr, setUpdateExpr] = useState(new Function());

    return <Aux>
        {isNewCP() && !props.isCommercialCP && <div className="language-select">
            <LanguageSelect defaultLanguage={props.defaultLanguage.label}
                            actionHandler={(language) => props.changeLanguage(language)}/>
        </div>}
        <h1 className={classes.drawerTitle}> {drawerTitle} </h1>

        <Stepper nonLinear activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepButton className={classes.button} onClick={handleStep(index)}>
                        <StepLabel>{translation(props.lang, label)}</StepLabel>
                    </StepButton>
                </Step>
            ))}
        </Stepper>

        <div className={classes.formContainer}>
            <div
                className={classes.formFields}>{getStepContent(activeStep)}</div>
            <hr/>
        </div>
        {activeStep === steps.length - 1 && isOnEditingExpr ?
            <ButtonsStrip maxWidth={{maxWidth: '80%'}}
                          lang={props.lang}
                          rightButtons={[
                              {
                                  label: "Confirm",
                                  variant: "success",
                                  isVisible: true,
                                  actionHandler: () => confirmUnsavedExpr(),
                                  isDisabled: unsavedExprOpenPopup || !hasUnsavedExpr || isAnyEmptyExprField(),
                              },
                              {
                                  label: "Cancel",
                                  variant: "danger",
                                  isVisible: true,
                                  actionHandler: () => cancelUnsavedExpr(),
                                  isDisabled: unsavedExprOpenPopup,
                              }]}
                          popup={{
                              anchorEl: unsavedExprPopupLauncher,
                              show: unsavedExprOpenPopup,
                              onClose: (_, reason) => {
                                  if (reason !== "backdropClick") {
                                      hideUnsavedExprPopup();
                                  }
                              },
                              title: translation(props.lang, "Unsaved changes"),
                              body: translation(props.lang, "Changes you just made are not confirmed yet"),
                              cancelBtnLabel: "Ok",
                              cancelBtnVariant: "success",
                              oneButton: true,
                          }}
            /> :
            <ButtonsStrip
                maxWidth={{maxWidth: '80%'}}
                lang={props.lang}
                dict={props.dict}
                buttons={[
                    {
                        label: buttons.save,
                        variant: "success",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.save),
                        tooltipInfo: infoTexts["save"],
                        actionHandler: () => saveFileHandler()
                    },
                    {
                        label: buttons.addCommercialCV,
                        variant: "success",
                        isDisabled: disableAddCommercialBtn,
                        isVisible: isBtnVisible(buttons.addCommercialCV),
                        actionHandler: (e) => handleCreateNewCommercial(e),
                        popup: {
                            anchorEl: popupLauncher,
                            show: (_.isEqual(openPopup, buttons.addCommercialCV)),
                            onClose: () => hidePopup(),
                            onSubmit: () => {
                                hidePopup()
                                saveNewCommercial(versionedFileName)
                            },
                            submitBtnLabel: "Save",
                            cancelBtnLabel: "Cancel",
                            title: "Save new version ?",
                            body: `${translation(props.lang, `Another Consultant Profile with the same name already exists,\nDo you want to save this new version as`)} "${versionedFileName.replace(".xml", "")}" ?`,
                        }
                    },
                    {
                        label: buttons.share,
                        variant: "success",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.share),
                        tooltipInfo: infoTexts["share"],
                        actionHandler: (e) => launchPopup(e, buttons.share),
                        hasMailingPopup: true,
                    },
                    {
                        label: buttons.notify,
                        variant: "success",
                        isVisible: isBtnVisible(buttons.notify),
                        tooltipInfo: infoTexts["notify"],
                        actionHandler: (e) => launchPopup(e, buttons.notify),
                        hasMailingPopup: true,
                    },
                    {
                        label: buttons.forceValidation,
                        variant: "success",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.forceValidation),
                        tooltipInfo: infoTexts["forceValidation"],
                        actionHandler: (e) => launchPopup(e, buttons.forceValidation),
                        popup: {
                            anchorEl: popupLauncher,
                            show: (_.isEqual(openPopup, buttons.forceValidation)),
                            onClose: () => hidePopup(),
                            onSubmit: () => forceValidationHandler(),
                            title: "Force Validation ?",
                            body: "This will force Consultant Profile validation without notifying the consultant",
                        }
                    },
                    {
                        label: buttons.validate,
                        variant: "success",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.validate),
                        tooltipInfo: infoTexts["validate"],
                        actionHandler: (e) => launchPopup(e, buttons.validate),
                        hasMailingPopup: true,
                    },
                    {
                        label: buttons.invalidate,
                        variant: "danger",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.invalidate),
                        tooltipInfo: infoTexts["invalidate"],
                        actionHandler: (e) => launchPopup(e, buttons.invalidate),
                        hasMailingPopup: true,
                    },
                    {
                        label: buttons.generate,
                        variant: "success",
                        isDisabled: disableBtn,
                        isVisible: isBtnVisible(buttons.generate),
                        actionHandler: (e) => launchPopup(e, buttons.generate),
                        popup: {
                            anchorEl: popupLauncher,
                            show: (_.isEqual(openPopup, buttons.generate)),
                            onClose: () => hidePopup(),
                            downloadDocxFile: () => {
                                generateLocalDocument(token, props.webUrl, props.siteId, fileName, props.lang, cvDetails, FileExtensionEnum.DOCX).then(() => hidePopup())
                            },
                            downloadPdfFile: () => {
                                generateLocalDocument(token, props.webUrl, props.siteId, fileName, props.lang, cvDetails, FileExtensionEnum.PDF).then(() => hidePopup())
                            },
                            DocxBtnLabel: FileExtensionEnum.DOCX,
                            PdfBtnLabel: FileExtensionEnum.PDF,
                            title: "Download document",
                            body: "Please choose the type of document",
                            downloadButton: true,
                        }
                    },
                    {
                        label: buttons.close,
                        variant: "danger",
                        isVisible: true,
                        actionHandler: (e) => handleCloseDrawer(e),
                        popup: {
                            anchorEl: popupLauncher,
                            show: (_.isEqual(openPopup, buttons.close)),
                            onClose: () => hidePopup(),
                            onSubmit: () => discardChanges(),
                            title: "Delete changes ?",
                            body: "This will delete the unsaved changes you just made",
                        }
                    }]}
                mailingPopup={{
                    lang: props.lang,
                    token: token,
                    siteId: props.siteId,
                    fileId: fileId,
                    openPopup: openPopup,
                    popupLauncher: popupLauncher,
                    hidePopup: hidePopup,
                    changeStatus: (s) => changeCVStatus(s),
                    onLoading: (v) => handleLoading(v),
                    notify: (m, s) => props.notify(m, s),
                    sleep: (t) => sleep(t),
                    reload: () => props.reloadReference(),
                    consultantEmail: consultantEmail,
                    fileName: fileName,
                    closeDrawer: props.closeDrawer,
                    hasNewEmail: (emailBeforeChange !== cvDetails.SkillsPassport.LearnerInfo.Identification.ContactInfo.Email.Contact._text),
                    saveNewEmail: async (permissionCode) => saveNewEmail(permissionCode)
                }}
                rightButtons={[
                    {
                        label: "Back",
                        variant: "primary",
                        isVisible: "true",
                        actionHandler: () => handleBack(),
                        isDisabled: (activeStep === 0),
                    },
                    {
                        label: "Next",
                        variant: "primary",
                        isVisible: "true",
                        actionHandler: () => handleNext(),
                        isDisabled: (activeStep === steps.length - 1),
                    }]
                }
            />}
    </Aux>
};

export default Accordion;

// functions

// capitalize characters following a space
let capitalize = (s) => {
    return s.replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase()
    })
}

let html2text = (v) => {
    return v ? v.replace(/(<([^>]+)>)/gi, "") : "";
}

let isEmptyField = (v) => {
    return _.isEqual(v, {}) || _.isEqual(v, {_text: ""}) || html2text(v._text) === "";
}

let isEqualField = (a, b) => {
    return _.isEqual(a, b) || (isEmptyField(a) && isEmptyField(b));
}

let array = (v) => {
    return Array.isArray(v) ? v : _.isEmpty(v) ? [] : Array(v);
}

let isEqualList = (a, b) => {
    return _.isEqual(array(a), array(b)) && array(a).filter(e => !array(b).includes(e));
}

let hasUnsavedChanges = (initial, current, isCommercial) => {
    let parser = new DOMParser;
    let initial1 = JSON.parse(parser.parseFromString(JSON.stringify(initial), 'text/html').body.textContent)
    let current1 = JSON.parse(parser.parseFromString(JSON.stringify(current), 'text/html').body.textContent)
    let i = initial1.SkillsPassport.LearnerInfo;
    let c = current1.SkillsPassport.LearnerInfo;

    return !((isCommercial ? _.isEqual(i.opportunity, c.opportunity) : true) &&
        isEqualField(i.Identification.PersonName.FirstName, c.Identification.PersonName.FirstName) &&
        isEqualField(i.Identification.PersonName.Surname, c.Identification.PersonName.Surname) &&
        isEqualField(i.Identification.Demographics.Gender.Code, c.Identification.Demographics.Gender.Code) &&
        isEqualField(i.Headline.Description.Label, c.Headline.Description.Label) &&
        isEqualField(i.Identification.ContactInfo.Email.Contact, c.Identification.ContactInfo.Email.Contact) &&
        isEqualField(i.ProfileOverview.Description.Label, c.ProfileOverview.Description.Label) &&
        isEqualField(i.Skills.TechnicalSkills.Description, c.Skills.TechnicalSkills.Description) &&
        isEqualField(i.EducationAndTraining.Education.Description, c.EducationAndTraining.Education.Description) &&
        isEqualField(i.EducationAndTraining.Training.Description, c.EducationAndTraining.Training.Description) &&
        isEqualField(i.EducationAndTraining.Certification.Description, c.EducationAndTraining.Certification.Description) &&
        isEqualList(i.Skills.Linguistic.LanguageList.Description, c.Skills.Linguistic.LanguageList.Description) &&
        isEqualList(i.WorkExperienceList.WorkExperience, c.WorkExperienceList.WorkExperience));
}